export default __webpack_public_path__ + "static/media/1.0f87d181.jpg";